module.exports = __webpack_public_path__ + "img/no.d107e90b.svg";